import React, { useEffect, useRef, useState } from "react";
import { useOthersStore } from "../../store/othersStore.js";
import { Link } from "react-router-dom";
import {
  Table,
  ConfigProvider,
  Input,
  Select,
  DatePicker,
  Popconfirm,
} from "antd";
import moment from "moment";

import { VioletButtonLarge } from "../../components/button";


import images from "../../assets";

const { RangePicker } = DatePicker;

export default function Author() {
  const { authors, isAuthorLoading, getAuthors, deleteAuthor } =
    useOthersStore();
  const tableRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (authors.length === 0) {
      fetchAuthors();
    } else {
      applyFilters();
    }
  }, [authors, searchText]);

  const fetchAuthors = async () => {
    getAuthors({});
  };

  const applyFilters = () => {
    let filtered = authors;

    if (searchText) {
      filtered = filtered?.filter((item) =>
        item?.displayName?.toLowerCase().includes(searchText?.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleDelete = (id) => {
    const payload = { id: id };
    deleteAuthor(payload, () => {
      fetchAuthors();
    });
  };

  const handleTableChange = (pagination) => {
    setCurrentPage(pagination.current);
    setPageSize(pagination.pageSize);

    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const columns = [
    {
      title: "ID",
      width: 70,
      render: (text, record) => record?.id,
      key: "1",
    },
    {
      title: "Image",
      width: 80,

      render: (text, record) => (
        <img src={record?.imageUrl} alt="img" className="h-[40px] w-max" />
      ),
      key: "2",
    },
    {
      title: "Name",
      key: "3",
      width: 150,
      render: (text, record) => record?.displayName,
      fixed: "left",
    },
    {
      title: "Title",
      key: "11",
      width: 130,
      render: (text, record) => record?.profileTitle,
      fixed: "left",
    },
    {
      title: "Email",
      key: "4",
      render: (text, record) => record?.userEmail,
      width: 150,
    },
    {
      title: "RegisterDate",
      key: "6",
      render: (text, record) =>
        moment(record?.userRegistered).format("DD.MM.YYYY"),
      width: 100,
    },

    {
      title: "Action",
      key: "17",
      fixed: "right",
      align: "center",
      width: 80,
      render: (text, record) => (
        <div className="flex gap-2 flex-wrap">
          <Link to={`/author/${record?.id}`}>
            <img src={images.editIcon} alt="" />
          </Link>
          <Popconfirm
            title="Delete author?"
            description="Are you sure you want to delete this author?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <img src={images.deleteIcon} alt="" />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="w-full p-4 text-black">
      <div ref={tableRef}></div>
      <div className="mb-4 grid grid-cols-4 gap-5 items-end">
        <div className="flex flex-col gap-2 w-full">
          <div>Search</div>
          <Input
            style={{ height: 48 }}
            className="blog"
            placeholder="Keywords"
            onChange={(e) => handleSearch(e.target.value)}
            value={searchText}
          />
        </div>
        <Link to={"/addAuthor"} className="w-max">
          <VioletButtonLarge text="Add Author" />
        </Link>
      </div>
      <div>
        Total authors: <strong>{filteredData?.length}</strong>
      </div>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#310048",
              headerColor: "#ffffff",
              cellFontSize: "14px",
              headerSortHoverBg: "#310048",
              headerSortActiveBg: "",
            },
          },
        }}
      >
        <Table
          className="user-list"
          bordered
          columns={columns}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: ["50", "100", "500", "1000"],
            showSizeChanger: true,
            total: filteredData.length,
          }}
          dataSource={filteredData}
          scroll={{
            x: 1500,
            y: 600,
          }}
          loading={isAuthorLoading}
          rowKey={(record) => record?.id}
          onChange={handleTableChange}
        />
      </ConfigProvider>
    </div>
  );
}








